import { useCallback, useRef } from 'react';
import { runEvent } from 'scripts/animations/three/utils/run';
import { HomeHero } from 'scripts/animations/three/home-hero';
import { PrimaryIconMaterial, SecondaryIconMaterial } from './common/materials';
import { GLTFData } from 'scripts/animations/three/types/gltf';
import { useGLTF } from '@react-three/drei';
import { HoverWrapper } from 'scripts/animations/three/helpers/hoverWrap';

import ModelUrl from 'assets/gl/home/hero/dashboard.glb?url';

type DashboardProps = JSX.IntrinsicElements['group'] & {
    // nothing here yet!
};

type DashboardGLTF = GLTFData<
    'Tube' | 'Tube1' | 'Tube2' | 'Cylinder' | 'Capsule_2' | 'Capsule_3'
>;

export const Dashboard = (props: DashboardProps) => {
    const { nodes } = useGLTF(ModelUrl) as DashboardGLTF;
    const {
        Tube,
        Tube1,
        Tube2,
        Cylinder,
        Capsule_2,
        Capsule_3,
    } = nodes;

    const rootRef = useRef<THREE.Group>();

    const onHover = useCallback(() => {
        runEvent(HomeHero.Events.Hover.Dashboard, { root: rootRef.current });
    }, []);

    const onHoverOut = useCallback(() => {
        runEvent(HomeHero.Events.Hover.DashboardOut, { root: rootRef.current });
    }, []);

    return (
        <group
            ref={rootRef}
            name="Dashboard"
            position={[-560.21, 5, 11.14]}
            {...props}
        >
            <group name="dash_float" position={[1.62, -0.53, -1.42]}>
                <HoverWrapper
                    name="dash_hover"
                    onPointerEnter={onHover}
                    onPointerOut={onHoverOut}
                    scale={1.4}
                />
                <group
                    name="Dashboard1"
                    position={[-5.6, -6.96, -2.02]}
                    rotation={[2.78, -1.1, 2.92]}
                    scale={2.3}
                >
                    <group name="Null1" position={[0, 0, -8.21]} rotation={[Math.PI / 2, Math.PI / 4, 0]}>
                        <mesh
                            name="Tube"
                            geometry={Tube.geometry}
                            material={SecondaryIconMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 1.7, 0]}
                        />
                        <mesh
                            name="Tube1"
                            geometry={Tube1.geometry}
                            material={SecondaryIconMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 1.7, 0]}
                            rotation={[0, 1.57, 0]}
                        />
                        <mesh
                            name="Tube2"
                            geometry={Tube2.geometry}
                            material={SecondaryIconMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 1.7, 0]}
                            rotation={[0, -1.57, 0]}
                        />
                    </group>
                    <mesh
                        name="Cylinder"
                        geometry={Cylinder.geometry}
                        material={PrimaryIconMaterial}
                        castShadow
                        receiveShadow
                        position={[0, 0, 0]}
                        rotation={[Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                        name="Capsule_2"
                        geometry={Capsule_2.geometry}
                        material={PrimaryIconMaterial}
                        castShadow
                        receiveShadow
                        position={[0, 0, -10.68]}
                        rotation={[Math.PI / 2, -1.15, 0]}
                        scale={1}
                    >
                        <mesh
                            name="Capsule_3"
                            geometry={Capsule_3.geometry}
                            material={PrimaryIconMaterial}
                            castShadow
                            receiveShadow
                            position={[-10.29, 1.29, 0]}
                            rotation={[0, 0, -Math.PI / 2]}
                            scale={1}
                        />
                    </mesh>
                </group>
            </group>
        </group>
    );
};

export const preloader = () => useGLTF.preload(ModelUrl);
